import { useMemo } from 'react';
import { ReportType, TemplateIndex } from '../../ReportsIndexPage/Report.types';
import { sortReportColumns } from './Grid.utils';
import {
    appendClickableColumns,
    createColumnsBasedOnDataKeys,
} from './ReportsGrid.utils';
import {
    PaymentPaymentableIDFormKey,
    PaymentPaymentableType,
    PaymentPaymentableTypeFormKey,
} from './FormsGrid.constants';
import { ExtraColumnDefinitionData } from '~/components/Grid';

const useColumnsFromKeys = <
    ReportData extends { keys: Array<string>; data: Array<unknown> },
>(
    formsReport: ReportData | null,
    reportType: ReportType,
    templateSelected?: TemplateIndex,
    extraData?: ExtraColumnDefinitionData,
) => {
    return useMemo(() => {
        if (formsReport) {
            const { keys } = formsReport as ReportData;
            const columns = createColumnsBasedOnDataKeys<ReportData>(
                keys,
                templateSelected,
            );

            function handleSet(params) {
                console.log('handleSet params=', params?.id)
                if (params?.id?.type === PaymentPaymentableType.FormSubmission) {
                    extraData?.setSelectedFormSubmission({
                        submission: {id: params?.id?.id}
                    })
                } else {
                    console.log('setting event to', params?.id?.id || params?.id)
                    extraData?.setSelectedEvent({id: params?.id?.id || params?.id})
                }
            }

            const itemsToAppend =
                appendClickableColumns(
                    [
                        {
                            condition:
                                reportType === ReportType.Events &&
                                extraData?.setSelectedEvent != null,
                            idExtractor: params => params.data?.id,
                        },
                        {
                            condition:
                                reportType === ReportType.Payments &&
                                extraData?.setSelectedEvent != null,
                            idExtractor: params => {
                                return (params.data?.[PaymentPaymentableIDFormKey] &&
                                    (params.data?.[PaymentPaymentableTypeFormKey] ===
                                        PaymentPaymentableType.BookingEvent || params.data?.[PaymentPaymentableTypeFormKey] ===
                                        PaymentPaymentableType.FormSubmission)) ? {type: params.data?.[PaymentPaymentableTypeFormKey], id: params.data?.[PaymentPaymentableIDFormKey]} : '';
                            },
                            fallbackValue: '-',
                        },
                        {
                            condition:
                                reportType === ReportType.Clients &&
                                extraData?.setSelectedEvent != null,
                            idExtractor: params => params.data?.['Client ID'] || params.data?.['Client Id'] || params.data?.['client-id'],
                        },
                    ],
                    handleSet,
                ) ?? [];
            if (itemsToAppend.length > 0) {
                columns.push(...itemsToAppend);
            }

            return sortReportColumns(columns, reportType);
        }
        return [];
    }, [formsReport, reportType, templateSelected, extraData]);
};

export default useColumnsFromKeys;
